module.exports = __webpack_public_path__ + "static/media/r2-d2.deeaaf40.jpg";